import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';

import Date from '../../Form/Field/Date.jsx';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Input from '../../Form/Field/Input.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';

import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import normBoolean from '../../Form/Normalizer/boolean.js';
import validate from './validate.js';

export const name = 'AvailabilityForm';

class AvailabilityForm extends Component {
  static propTypes = {
    className: PropTypes.string,
    center: PropTypes.bool,
    withPublic: PropTypes.bool
  };

  static defaultProps = {
    className: '',
    withPublic: false,
    center: true
  };

  render() {
    return (
      <div id={name} className={this.props.className}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className={`row ${this.props.center ? 'justify-content-center' : ''}`}>
            <div className="col-md-6">
              <Field
                label="Date de disponibilité"
                name="date_available"
                placeholder="JJ/MM/AAAA"
                type="text"
                component={Date} />
            </div>
          </div>
          {this.props.withPublic && 
          <div className={`row ${this.props.center ? 'justify-content-center' : ''}`}>
            <div className="col-md-6">
              <Field
                label="Profil public"
                name="public"
                type="checkbox"
                normalize={normBoolean}
                component={Input} />
            </div>
          </div>}
          <input className="d-none" type="submit" />
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit} />
      </div>
    );
  }
}

export default reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(AvailabilityForm);